<isav-simple-search-container>
    <ng-container isavSimpleSearchContent>
        <h1 class="title is-1 has-text-centered">Search infrastructure</h1>
        <form [formGroup]="searchForm" isavSimpleSearchForm (ngSubmit)="search()">
            <div class="field">
                <div class="control is-expanded has-icons-left">
                    <input
                        formControlName="text"
                        type="search"
                        class="input"
                        placeholder="Type text to search for infrastructure"
                        aria-label="text to use in infrastructure search"
                        id="infrastructure-text-input"
                    />
                    <isav-icon icon="search" class="is-small is-left"></isav-icon>
                </div>
            </div>

            <div class="field">
                <div class="control">
                    <isav-type-taxonomy-select
                        formControlName="type"
                        placeholder="Select infrastructure type"
                        class="mb-4"
                        [multiple]="true"
                    ></isav-type-taxonomy-select>
                </div>
            </div>

            <div class="field is-grouped is-grouped-centered">
                <div class="control">
                    <button isavBtn type="submit" color="success" class="simple-search-submit">
                        Search
                    </button>
                </div>
            </div>
            <p class="help mt-4 has-text-right">
                <a [routerLink]="['search']"> Advanced search </a>
            </p>
        </form>
    </ng-container>
</isav-simple-search-container>

<div class="page-container page-container-vertical">
    <h2 class="title is-2">Latest</h2>
    <div class="columns is-multiline">
        <isav-landing-card
            *ngFor="let infrastructure of newestInfrastructures$ | async"
            [image]="infrastructure.image"
        >
            <ng-container isavLandingCardCaption>
                Types:&nbsp;
                <isav-taxonomies-names [iris]="infrastructure.types"></isav-taxonomies-names>
            </ng-container>
            <a
                isavLandingCardHeading
                [routerLink]="linkTo(infrastructure)"
                [queryParams]="{ iri: infrastructure['@id'] }"
            >
                {{ infrastructure.name }}
            </a>
            <p isavLandingCardFooter>
                <strong>Location:&nbsp;</strong><br />
                {{infrastructure.coordinates | isavGeoLocation}}
            </p>
        </isav-landing-card>
    </div>
    <h2 class="title is-2">Infrastructures</h2>
    <div class="columns is-multiline">
        <isav-landing-card
            *ngFor="let infrastructure of randomInfrastructures$ | async"
            [image]="infrastructure.image"
        >
            <ng-container isavLandingCardCaption>
                Types:&nbsp;
                <isav-taxonomies-names [iris]="infrastructure.types"></isav-taxonomies-names>
            </ng-container>
            <a
                isavLandingCardHeading
                [routerLink]="linkTo(infrastructure)"
                [queryParams]="{ iri: infrastructure['@id'] }"
            >
                {{ infrastructure.name }}
            </a>
            <p isavLandingCardFooter>
                <strong>Location:&nbsp;</strong><br />
                {{infrastructure.coordinates | isavGeoLocation}}
            </p>
        </isav-landing-card>
    </div>
</div>
